import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: '2825a48f-a3c4-4e87-ae97-7b3a730a6e2a',
    countryCodes: ['SK'],
    locale: 'sk-SK',
    enable: {
        prelaunch: false,
    },
});
